import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';

/**
 * ログイン (認証が終わったらリダイレクトするだけの空画面)
 * @export
 * @class LoginComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {

  /**
   * コンストラクタ
   * @param {Router} router
   * @param {AuthService} authService
   * @memberof LoginComponent
   */
  constructor(private router: Router, private authService: AuthService) {

    let url: string = sessionStorage.getItem('returnUrl');
    if (url == null || url == 'null' || url == 'undefined' || url == '') {
      url = '/sgkz001d';
    }

    this.authService.tryLogin().subscribe(
      async _ => {
        if (this.authService.isAuthenticated()) {

          this.authService.autoUpdateToken();
          this.router.navigateByUrl(url);
        } else {

          this.authService.transition2Login();
        }
      },
    );
  }
}
